/* eslint-disable import/no-anonymous-default-export */
import { Form, Input, Modal, Table, message, Select, Button } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import { useEffect, useState } from "react";
import DataFilter from "../common/components/DataFilter";
import DataTable from "../common/components/DataTable";
import EditableCell from "../common/components/EditableCell";
import MainLayout from "../common/components/MainLayout";
import useConveniosPagoConfiguracionesAPI, { ConveniosPagoConfiguracion, ConveniosPagoConfiguracionSave } from "./useConveniosPagoConfiguracionesAPI";
import { StockOutlined } from "@ant-design/icons";
import useInfraccionesAPI from "../infracciones/hooks/useInfraccionesAPI";
import { optionsYear, optionsMonth } from "./options";
import moment from "moment-business-days";

interface EstadisticasPago {
    pagasMes: number    
    impagasMes: number    
    pagas:number
    impagas:number
    totalMes: number
    total:number    
}

const date = moment();
const now = date.format("YYYY-MM-DD");
const year = date.year();
const month = date.month();

export default () => {
    const api = useConveniosPagoConfiguracionesAPI();
    const infraccionesApi = useInfraccionesAPI()
    const createPage = "/convenios-pago/configuraciones/guardar"
    const editPage = "/convenios-pago/configuraciones/guardar/{Id}"    

    const [showEstadisticasPago, setShowEstadisticasPago] = useState(false)
    const [estadisticasPago, setEstadisticasPago] = useState<EstadisticasPago>({
        pagasMes: 0,        
        impagasMes: 0,        
        pagas: 0,
        impagas: 0,
        totalMes: 0,
        total: 0
    })
    const [selectedMonth, setSelectedMonth] = useState<number>(optionsMonth[0].value);
    const [selectedYear, setSelectYear] = useState<number>(optionsYear[0].value);
    const [id, setId] = useState<number[]>([]);    

    const [nombreFilterForm] = Form.useForm();
    const generateFilters = (filters:Record<string, FilterValue | null>) => {
        return [
            filters?.Nombre != null ?  `contains(Nombre,'${filters!.Nombre![0]}')` : "",            
        ];
    }

    const getEstadisticasPago = async (item:ConveniosPagoConfiguracion, selectedMonth: number, selectedYear: number) => 
    {        
        const estadisticas = await infraccionesApi.getEstadisticasPagos(
            item.ConfiguracionesProduccion.map(c => c.Id), selectedMonth, selectedYear, now
        )
        if(estadisticas.error)
        {
            message.error("Error al obtener las estadísticas de pago")
            return
        }
        
        setEstadisticasPago({
            pagasMes: estadisticas.pagasMes!,            
            impagasMes: estadisticas.impagasMes!,            
            impagas:estadisticas.impagas!,
            pagas:estadisticas.pagas!,
            totalMes: estadisticas.totalMes,
            total:estadisticas.total!                      
        })
        setId(item.ConfiguracionesProduccion.map(c => c.Id));
        setShowEstadisticasPago(true)
    }

    useEffect(() => {
        setSelectedMonth(selectedMonth);
    }, [selectedMonth]);

    const handleSubmit = async () => {        
        const estadisticas = await infraccionesApi.getEstadisticasPagos(
            id, selectedMonth, selectedYear, now
        )
        if(estadisticas.error)
        {
            message.error("Error al obtener las estadísticas de pago")
            return
        }
        
        setEstadisticasPago({
            pagasMes: estadisticas.pagasMes!,            
            impagasMes: estadisticas.impagasMes!,            
            impagas:estadisticas.impagas!,
            pagas:estadisticas.pagas!,
            totalMes: estadisticas.totalMes,
            total:estadisticas.total!
        })        
        setShowEstadisticasPago(true)
    };

    return (
        <MainLayout >
            <Modal 
            open={showEstadisticasPago} 
            onCancel={()=>setShowEstadisticasPago(false)}
            onOk={()=>setShowEstadisticasPago(false)}
            cancelButtonProps={{hidden:true}}            
            >
                <div><strong>Estadísticas de cobranza</strong></div><br/>
                <Select id = "month-select" value = {selectedMonth} onChange = {(e) => setSelectedMonth(e)} listHeight={500}>
                        {
                            optionsMonth.map(option => (
                                <Select.Option key = {option.value} value = {option.value}>{option.text}</Select.Option>
                            ))
                        }
                </Select>
                <Select id = "year-select" value = {selectedYear} onChange = {(e) => setSelectYear(e)} listHeight={500} style = {{ marginLeft: "5px" }}>
                        {
                            optionsYear.map(option => (
                                <Select.Option key = {option.value} value = {option.value}>{option.text}</Select.Option>
                            ))
                        }
                </Select>                
                <Button type = "primary" value = {"Consulta"} onClick={() => handleSubmit()} style = {{ marginLeft: "5px" }}>
                    Consultar
                </Button>
                <br/><br/>                
                <div><strong>Pagas: </strong>{estadisticasPago.pagasMes} ({ estadisticasPago.pagasMes !== 0 ? Math.round(estadisticasPago.pagasMes / estadisticasPago.totalMes * 100) : 0 } %)</div>                
                <div><strong>Impagas (Pago voluntario vencido): </strong>{estadisticasPago.impagasMes} ({ estadisticasPago.impagasMes !== 0 ? Math.round(estadisticasPago.impagasMes / estadisticasPago.totalMes * 100) : 0 } %)</div>
                <div><strong>Total: </strong>{estadisticasPago.totalMes}</div>
                <br/>
                <p><strong>Global</strong></p>
                <div><strong>Pagas: </strong>{estadisticasPago?.pagas} ({ estadisticasPago.pagas !== 0 ? Math.round(estadisticasPago.pagas / estadisticasPago.total * 100) : 0 } %)</div>
                <div><strong>Impagas (Pago voluntario vencido): </strong>{estadisticasPago?.impagas} ({ estadisticasPago.impagas !== 0 ? Math.round(estadisticasPago.impagas / estadisticasPago.total * 100) : 0 } %)</div>
                <div><strong>Total: </strong>{estadisticasPago?.total}</div>
            </Modal>
            <DataTable<ConveniosPagoConfiguracion,ConveniosPagoConfiguracionSave>
            list={api.list}
            delete={api.delete}
            $expand={['ConfiguracionesProduccion']}
            createAction={{
                label:"Agregar configuración de convenios de pago",
                path:createPage
            }}
            itemActions={[
                {
                    action: async (item, selectedItems) => getEstadisticasPago(item, month, year),
                    key:'estadisticas-pago',
                    label:'Estadísticas de pago',
                    icon:<StockOutlined />                                        
                }
            ]}
            deleteMultipleAction
            defaultSortOrder={"Id asc"}
            selectionType='checkbox'
            title={"Configuraciones de convenios de pago"}
            generateFilters={generateFilters}
            editItemAction={editPage}
            deleteItemAction
            deleteItemActionConfirmMessage={(item) => `¿Eliminar configuración ${item.Nombre}?`}
            defaultPageSize={25}
            
            >

                <Table.Column<ConveniosPagoConfiguracion>
                    width={`5%`}
                    title="ID"
                    dataIndex={"Id"}
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend","descend","ascend"]}
                />

                <Table.Column<ConveniosPagoConfiguracion>
                    width={`85%`}
                    title="Nombre"
                    dataIndex={"Nombre"}
                    sorter
                    render={(val, record)=>
                        <EditableCell<Partial<ConveniosPagoConfiguracion>>
                            save={(c)=>api.save({Nombre:c.Nombre})}
                            id={record.Id}
                            render={(value)=>value.Nombre!}
                            formValue={{Nombre:val}}
                            formItem={<Form.Item style={{marginBottom:0}} name={"Nombre"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend","descend","ascend"]}
                    filterDropdown={(props)=>{
                        return (
                            <DataFilter filterDropdownProps={props} form={nombreFilterForm} >
                                <Form.Item name={"Nombre"} style={{marginBottom:10}}>
                                    <Input placeholder='Nombre...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                   }
                   
                />

            </DataTable>
        </MainLayout>
    );
};